// 全局指令 节流
export default (app: any) => {
    app.directive('preventReClick', {
        mounted(el: any, binding:any) {
            el.addEventListener('click', () => {
                if (!el.disabled) {
                    el.disabled = true;
                    setTimeout(() => {
                        el.disabled = false;
                    }, binding.value || 3000);
                }
            });
        }
    })
  }
  